import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitomatherancabs() {



  const cardData =
  {
    keyword: 'Mumbai to Matheran Cab',
    heading: 'Shambhu Cabs: Mumbai to Matheran Cab  ',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Matheran Cab services, providing safe, comfortable, and hassle-free travel for families, friends, corporate travelers, and weekend getaway seekers heading to the serene hill station of Matheran. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Matheran with well-maintained vehicles and spacious seating. With flexible one-way and round-trip options, experienced chauffeurs, and 24/7 booking support, Shambhu Cabs makes your trip stress-free and convenient. From South Mumbai to Thane, Andheri to Vashi, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Matheran cab services for travelers seeking comfort, safety, and a memorable travel experience..',

    top: 'Top Places to Visit in Matheran with Shambhu Cabs',

 "topPlaces": [
  {
    "title": "Panorama Point",
    "description": "Panorama Point is a famous viewpoint in Matheran offering breathtaking views of the surrounding valleys and hills. It is an ideal spot for sunrise and sunset photography and provides a serene atmosphere away from the crowds."
  },
  {
    "title": "Charlotte Lake",
    "description": "Charlotte Lake is a calm and scenic lake surrounded by lush greenery. Visitors enjoy picnics, peaceful walks along the lakeside, and birdwatching in this tranquil natural setting."
  },
  {
    "title": "Echo Point",
    "description": "Echo Point is a unique spot where visitors can shout and hear their voices echoing back from the surrounding hills. It is a popular attraction for families and adventure enthusiasts exploring Matheran."
  },
  {
    "title": "Louisa Point",
    "description": "Louisa Point offers panoramic views of the Western Ghats, including Prabalgad Fort and the Ulhas Valley. It is a serene and scenic viewpoint, perfect for photography and enjoying nature’s beauty."
  },
  {
    "title": "Monkey Point",
    "description": "Monkey Point is a hilltop vantage point named for the monkeys that inhabit the area. It provides stunning views of the sunset, surrounding hills, and forests, making it a popular stop for trekkers and tourists."
  },
  {
    "title": "One Tree Hill Point",
    "description": "One Tree Hill Point is a tranquil spot with a solitary tree offering panoramic views of the valleys and distant hills. It is ideal for nature walks, meditation, and photography."
  },
  {
    "title": "Alexander Point",
    "description": "Alexander Point is known for its scenic viewpoints overlooking the Ghats and valleys below. It is a quiet spot popular among trekkers and photographers seeking less crowded locations."
  },
  {
    "title": "Charlotte Lake Sunset Point",
    "description": "Located near Charlotte Lake, this point offers spectacular sunset views with reflections over the water and the surrounding greenery, making it a favorite for tourists and nature enthusiasts."
  },
  {
    "title": "Table Land",
    "description": "Table Land is a vast flat plateau in Matheran, ideal for walking, horse riding, and enjoying panoramic views of the surrounding hills. Its unique landscape and open space make it one of Matheran’s most popular attractions."
  },
  {
    "title": "Porcupine Point",
    "description": "Porcupine Point is a cliff-edge viewpoint offering mesmerizing views of the Western Ghats, valleys, and Prabalgad Fort. It is popular among trekkers and adventure seekers for its stunning scenery."
  }
],


"services": [
  {
    "name": "Mumbai Matheran Taxi",
    "description": "Mumbai Matheran Taxi provides reliable and comfortable transportation from Mumbai to the scenic hill station of Matheran. With professional drivers, well-maintained vehicles, and flexible scheduling, this service ensures a smooth and stress-free journey. Ideal for family trips, solo travelers, and corporate clients, passengers can enjoy timely pickups, scenic routes, and a safe ride through the Western Ghats."
  },
  {
    "name": "One-Way Cab Mumbai Matheran",
    "description": "One-Way Cab Mumbai Matheran is designed for travelers requiring a single-drop service to Matheran without a return trip. Perfect for weekend getaways, business visits, or leisure travel, this service provides professional drivers, comfortable vehicles, and transparent pricing for a hassle-free one-way journey."
  },
  {
    "name": "Matheran Hill Station Cab Mumbai",
    "description": "Matheran Hill Station Cab Mumbai offers specialized travel to Matheran, known for its toy train, viewpoints, and lush greenery. Passengers can enjoy a comfortable and scenic ride with experienced drivers familiar with the hill station routes, ensuring a safe and memorable journey for families, friends, and tourists."
  },
  {
    "name": "Affordable Matheran Cab",
    "description": "Affordable Matheran Cab provides budget-friendly options for intercity travel from Mumbai to Matheran. Despite economical pricing, the service maintains high standards of vehicle quality, safety, and comfort. Ideal for students, solo travelers, and families seeking cost-effective travel solutions."
  },
  {
    "name": "Best Cab Mumbai Matheran",
    "description": "Best Cab Mumbai Matheran is recognized for its superior service, punctual pickups, and well-maintained vehicles. With professional chauffeurs, a variety of cab options, and flexible booking, passengers experience a hassle-free and comfortable journey to the picturesque hill station of Matheran."
  },
  {
    "name": "SUV Matheran Cab",
    "description": "SUV Matheran Cab caters to families or groups traveling together from Mumbai to Matheran. Spacious vehicles equipped with modern amenities ensure a comfortable journey even on hilly roads, providing ample space for luggage and a smooth ride for all passengers."
  },
  {
    "name": "Sedan Cab Mumbai Matheran",
    "description": "Sedan Cab Mumbai Matheran offers elegant and efficient sedans for travelers seeking comfort and economy. With experienced drivers and well-maintained vehicles, passengers can enjoy a smooth and relaxed ride from Mumbai to Matheran, suitable for couples, solo travelers, or small families."
  },
  {
    "name": "Mumbai to Dasturi Point Cab",
    "description": "Mumbai to Dasturi Point Cab provides direct transportation to one of Matheran’s most popular viewpoints. This service ensures timely arrivals, safe driving through hill routes, and comfortable seating, making it perfect for tourists, photographers, and nature enthusiasts."
  },
  {
    "name": "24×7 Matheran Taxi Mumbai",
    "description": "24×7 Matheran Taxi Mumbai offers round-the-clock availability for travelers needing flexible timing. With experienced drivers, well-kept vehicles, and on-demand booking, passengers can enjoy a safe, comfortable, and convenient journey at any time of the day or night."
  },
  {
    "name": "Mumbai Matheran Outstation Cab",
    "description": "Mumbai Matheran Outstation Cab specializes in long-distance travel from Mumbai to Matheran, providing a focus on safety, comfort, and convenience. Vehicles are equipped with modern amenities, and drivers are trained for hill routes, ensuring a smooth and enjoyable ride for leisure and family trips."
  },
  {
    "name": "Family Cab Mumbai Matheran",
    "description": "Family Cab Mumbai Matheran caters specifically to family travel, offering spacious vehicles, professional drivers, and flexible itineraries. Passengers can enjoy sightseeing, a comfortable ride, and a memorable hill station experience with their loved ones."
  },
  {
    "name": "Fast Cab Mumbai Matheran",
    "description": "Fast Cab Mumbai Matheran focuses on punctual and time-efficient travel. Perfect for travelers on tight schedules or business trips, the service ensures direct routes, professional drivers, and well-maintained vehicles for a quick and comfortable journey to Matheran."
  },
  {
    "name": "Corporate Cab Mumbai Matheran",
    "description": "Corporate Cab Mumbai Matheran is designed for business travelers or corporate groups visiting Matheran. With premium vehicles, professional chauffeurs, and timely service, the cab ensures a comfortable, safe, and professional travel experience for work-related trips or client visits."
  },
  {
    "name": "Premium Cab for Matheran",
    "description": "Premium Cab for Matheran offers luxury vehicles and chauffeur-driven services for travelers seeking a high-end experience. Ideal for VIPs, executives, or special occasions, this service ensures maximum comfort, safety, and style during the journey from Mumbai to Matheran."
  },
  {
    "name": "Express Highway Cab Matheran",
    "description": "Express Highway Cab Matheran provides fast and efficient travel along highways connecting Mumbai to Matheran. Professional drivers, direct routes, and well-maintained vehicles allow passengers to reach their destination quickly while enjoying a safe and comfortable ride."
  },
  {
    "name": "Safe Taxi Mumbai Matheran",
    "description": "Safe Taxi Mumbai Matheran prioritizes passenger safety with experienced drivers, well-maintained vehicles, and adherence to all travel safety protocols. Perfect for families, solo travelers, and corporate clients, this service ensures a secure and dependable journey to Matheran."
  },
  {
    "name": "Mumbai to Matheran Pickup Drop",
    "description": "Mumbai to Matheran Pickup Drop offers door-to-door service for passengers traveling to Matheran. Professional drivers, comfortable vehicles, and flexible timing ensure maximum convenience, making this service ideal for both leisure travelers and corporate clients."
  }
],

"tableData": [
  ["Mumbai Matheran Taxi", "One-Way Cab Mumbai Matheran"],
  ["Matheran Hill Station Cab Mumbai", "Affordable Matheran Cab"],
  ["Best Cab Mumbai Matheran", "SUV Matheran Cab"],
  ["Sedan Cab Mumbai Matheran", "Mumbai to Dasturi Point Cab"],
  ["24×7 Matheran Taxi Mumbai", "Mumbai Matheran Outstation Cab"],
  ["Family Cab Mumbai Matheran", "Fast Cab Mumbai Matheran"],
  ["Corporate Cab Mumbai Matheran", "Premium Cab for Matheran"],
  ["Express Highway Cab Matheran", "Safe Taxi Mumbai Matheran"],
  ["Mumbai to Matheran Pickup Drop", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Matheran Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Matheran cab services, perfect for hill station trips, weekend getaways, and peaceful escapes from the city."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and well-serviced cabs for a smooth and relaxing journey to Matheran."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Ghat and Hill Routes",
    "WhyChoosedescription": "Our skilled drivers are familiar with the Mumbai to Matheran ghat and hill routes, ensuring safe, timely, and comfortable travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy upfront and clear pricing—fuel, tolls, and driver allowances included—making your Mumbai to Matheran cab trip hassle-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, travel queries, and route guidance."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Hill Station Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans tailored to your Mumbai to Matheran travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your Mumbai to Matheran journey stress-free and comfortable."
  }
]






















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Matheran cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Matheran cab services with professional and experienced drivers.',
  },
  {
    question: 'How can I book a Mumbai to Matheran cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for quick assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Matheran cab bookings?',
    answer: 'Shambhu Cabs offers well-maintained sedans, SUVs, and luxury cars suitable for a safe and comfortable trip to Matheran.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Matheran route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Mumbai to Matheran route, including the hill roads, to ensure a smooth journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Matheran cab?',
    answer: 'Absolutely. You can select your preferred pickup point in Mumbai and drop-off location anywhere near Matheran.',
  },
  {
    question: 'Is the Mumbai to Matheran cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock Mumbai to Matheran cab booking services to match your travel schedule.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Matheran cab bookings?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols for passenger well-being.',
  },
  {
    question: 'What payment options are available for Mumbai to Matheran cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during the Mumbai to Matheran journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mumbai to Matheran travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Pravin Joshi',
    feedback: 'Our Mumbai to Matheran trip with Shambhu Cabs was very comfortable. The driver was courteous and handled the hill roads expertly.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Patil',
    feedback: 'Highly reliable Mumbai to Matheran cab service. Smooth journey, clean car, and excellent support from Shambhu Cabs.',
    rating: 5,
  },
];















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Matheran Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-matheran-cab.jpg",
  "description": "Shambhu Cabs provides safe and comfortable Mumbai to Matheran cab services for hill station trips, family outings, and corporate travel. Book one-way or round-trip taxis with sedan, SUV, or premium cars. Ideal for visits to Matheran Hill Station, Dasturi Point, and express highway trips with professional drivers and affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-matheran-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Mumbai to Matheran Cab | Hill Station & Outstation Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Matheran cab with Shambhu Cabs. Safe, affordable, and comfortable taxi service for hill station trips, family outings, corporate travel, and visits to Dasturi Point. Available 24×7 with sedan, SUV, and premium cars."
  />

  <meta
    name="keywords"
    content="Mumbai Matheran Taxi, One-Way Cab Mumbai Matheran, Matheran Hill Station Cab Mumbai, Affordable Matheran Cab, Best Cab Mumbai Matheran, SUV Matheran Cab, Sedan Cab Mumbai Matheran, Mumbai to Dasturi Point Cab, 24×7 Matheran Taxi Mumbai, Mumbai Matheran Outstation Cab, Family Cab Mumbai Matheran, Fast Cab Mumbai Matheran, Corporate Cab Mumbai Matheran, Premium Cab for Matheran, Express Highway Cab Matheran, Safe Taxi Mumbai Matheran, Mumbai to Matheran Pickup Drop"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/14.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitomatherancabs;